let count = 0
export const generateElementName = () => `x-${count++}`
